import { API, graphqlOperation } from "@aws-amplify/api";
import React, { useState } from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook

import { customerAccessTokenCreateMutation } from "../graphql/mutations";

import { customerAccessTokenAtom } from "../atoms/authAtoms";
interface LoginFormState {
  email: string;
  password: string;
}
interface LoginFormProps {
  accessToken: any; // Change the type to match your actual accessToken type
}

const LoginForm: React.FC = () => {
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const [custAccessToken, setCustAccessToken] = useAtom(
    customerAccessTokenAtom
  );
  const handleLoginSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // Reset previous errors
    setErrors({
      email: "",
      password: "",
    });

    // Check if the email is not blank
    if (email.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "Please enter your email",
      }));
    }

    // Check if the password is not blank
    if (password.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: "Please enter your password",
      }));
    }

    // If both email and password are filled, proceed with form submission
    if (email.trim() !== "" && password.trim() !== "") {
      // console.log('Login form submitted');

      try {
        const input = {
          email: email,
          password: password,
          store: 'dev-4x4.sparesbox.com.au'  
        };

        const response = await API.graphql(graphqlOperation(customerAccessTokenCreateMutation, { input }));
        
        console.log("Response Data =>", response);
        
      } catch (error) {
        console.error("GraphQL Error =>", error);
      }
    }
  };

  return (
    <div className="container">
      <div
        className="card"
        style={{ display: showRegisterForm ? "none" : "block" }}
      >
        <div className="login-card">
          <h1 className="login-card__logo">Innoflex Shopping-Test</h1>
        </div>
        <h2 className="login-header">Login in</h2>
        <form onSubmit={handleLoginSubmit}>
          <label htmlFor="username" className="input-label">
            Email
          </label>
          <input
            type="text"
            id="username"
            className={errors.email ? "input-error" : ""}
            placeholder="Enter your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && (
            <span className="error-message">{errors.email}</span>
          )}
          <label htmlFor="password" className="input-label">
            Password
          </label>
          <input
            type="password"
            id="password"
            className={errors.password ? "input-error" : ""}
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {errors.password && (
            <span className="error-message">{errors.password}</span>
          )}
          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
